// extracted by mini-css-extract-plugin
export default {"sign":"SignUp_sign__ZWbOQ","signContainer":"SignUp_signContainer__gsBMh","title":"SignUp_title__-fvfb","formContainer":"SignUp_formContainer__T82i6"};